import React, { useState } from 'react';
import {
  Button, Modal, Upload, notification,
} from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { readZoneFile, warnAboutMissingQueues } from '../utils/zoneTransfer';

const { Dragger } = Upload;

// Кнопка «Импорт» + модалка с областью, куда можно бросить файл или кликнуть по ней.
// onImport получает разобранную зону { name, longname, description, config } без id —
// дальше страница сама решает, что с ней делать.
function ImportZoneButton({ onImport, size = 'large' }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleFile = async (file) => {
    const res = await readZoneFile(file);

    if (!res.status) {
      notification.error({
        message: res.errMessage,
      });
      return;
    }

    setIsOpen(false);
    onImport(res.data);
    warnAboutMissingQueues(res.data.config);
  };

  // beforeUpload синхронный: разбор файла запускаем сами, а antd просим
  // не загружать файл на сервер и не добавлять его в список
  const beforeUpload = (file) => {
    handleFile(file);
    return Upload.LIST_IGNORE;
  };

  return (
    <>
      <Button size={size} onClick={() => setIsOpen(true)}>Импорт</Button>
      <Modal
        title="Импорт зоны обслуживания"
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        destroyOnClose
      >
        <Dragger
          accept="application/json,.json"
          multiple={false}
          showUploadList={false}
          beforeUpload={beforeUpload}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Перетащите файл зоны сюда или нажмите для выбора
          </p>
          <p className="ant-upload-hint">
            JSON, выгруженный кнопкой экспорта из списка зон
          </p>
        </Dragger>
      </Modal>
    </>
  );
}

export default ImportZoneButton;
